import React from "react";
import { Shield, ShieldCheck } from "lucide-react";

/**
 * Rate-stability messaging. Deliberately non-specific — no rate figures displayed
 * publicly, to comply with s.21 FSMA and MCOB rules. The exact figures live inside
 * each customer's individual signed project contract.
 */
export default function StabilityChart() {
  return (
    <section className="py-14 md:py-20 border-t mv-hairline" data-testid="stability-chart">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Predictability</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          A predictable schedule. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>No surprises in the small print.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--mv-muted)" }}>
          Every developer instalment plan on MAVULA is disclosed in full inside your individual project contract — deposit, monthly amount, term and any applicable rate — before you sign. Nothing on this page is a financial promotion of a specific rate. Exact numbers vary by project, country and applicant.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { i: <Shield size={22}/>, t: "Written in your contract", d: "The numbers you see at signing are the numbers we honour — with no unilateral change." },
            { i: <ShieldCheck size={22}/>, t: "Independently checked", d: "A local lawyer reviews every schedule alongside you, where local law permits." },
            { i: <Shield size={22}/>, t: "No hidden layers", d: "Deposit, instalment, admin and legal fees are all disclosed on the same page." },
          ].map((c, i) => (
            <div key={i} className="mv-card p-5">
              <div className="w-11 h-11 rounded-2xl flex items-center justify-center mb-3 mv-green-text" style={{ background: "rgba(212,175,55,0.16)" }}>{c.i}</div>
              <div className="font-display text-[16px] mv-green-text">{c.t}</div>
              <p className="mt-1 text-[13.5px]" style={{ color: "var(--mv-muted)" }}>{c.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 text-[12px] font-accent italic" style={{ color: "var(--mv-muted)" }}>
          Illustrative only. Nothing here is a financial promotion, offer or forecast. Home-ownership plans are provided by our local project partners, not by MAVULA Investment Ltd, which is not an FCA-authorised mortgage lender or credit provider.
        </div>
      </div>
    </section>
  );
}
